import { useTranslation } from 'react-i18next'
import { FieldInput } from '@/components/form'

const TextField = ({ item, required, ...rest }) => {
  const { t } = useTranslation()

  return (
    <FieldInput
      name={item.name}
      placeholder={t(`l.contract.edit.${item.placeholder}.label`)}
      required={required}
      {...rest}
    />
  )
}

export default TextField
